import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol viewBox=\"0 0 15 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"trash\"><path d=\"M14.4 2.25v.9a.45.45 0 01-.45.45H.45A.45.45 0 010 3.15v-.9a.45.45 0 01.45-.45H4.5V.9a.9.9 0 01.9-.9H9a.9.9 0 01.9.9v.9h4.05a.45.45 0 01.45.45zM1.683 16.326A1.8 1.8 0 003.483 18h7.452a1.8 1.8 0 001.8-1.674L13.5 5.4H.9l.783 10.926z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol